import _ from "lodash";
import React from "react";
import I18nHOC from "UIComponents/I18nHOC";
import classes from "./ListPopup.scss";
import { Button, Dropdown } from "@toddle-edu/ds-web";
import List from "./List";
import classNames from "classnames";
import { LIST_POPUP_DIRECTION } from "Constants";

const ListPopup = React.memo(props => {
  const {
    id,
    data,
    dataCount = 0,
    mode,
    gradesName,
    label,
    singleLabel = label,
    overrideClasses = {},
    direction = LIST_POPUP_DIRECTION.LEFT,
    ListComponent = List,
    getPopupContainer,
    trigger = ["click"],
    keyToMap = "",
    customButtonVariant = "",
    userType,
    isDisabled: isDisabledProp = false,
    readFromDataCount = false,
    buttonType,
    dsVersion = "1.0",
    customButtonStyle = {},
    showTooltip = false,
    tooltipPlacement = "top",
    testId,
    customDropdownOverlayStyles = {},
    dir,
    innerComponent,
    children,
    componentProps = {},
    showSquareAvatar = false,
  } = props;
  const isDisabled = isDisabledProp || (_.isEmpty(data) && dataCount === 0);
  const filteredDataCount =
    readFromDataCount || dataCount
      ? dataCount
      : _.size(_.filter(data, element => !element.isArchived));

  const countLabel = filteredDataCount === 1 ? singleLabel : label;
  const dropdownOverlayStyle = {
    zIndex: 400,
  };

  const customOverlayStyles = _.isEmpty(customDropdownOverlayStyles)
    ? dropdownOverlayStyle
    : customDropdownOverlayStyles;

  return (
    <div
      className={classNames(
        classes.listPopupContainer,
        overrideClasses.listPopupContainer
      )}
    >
      <Dropdown
        overlayStyle={customOverlayStyles}
        disabled={isDisabled}
        getPopupContainer={getPopupContainer}
        trigger={trigger}
        overlay={
          <ListComponent
            id={id}
            value={data}
            isEditMode={mode == "edit"}
            gradesName={gradesName}
            direction={direction}
            keyToMap={keyToMap}
            userType={userType}
            showTooltip={showTooltip}
            tooltipPlacement={tooltipPlacement}
            dir={dir}
            innerComponent={innerComponent}
            componentProps={componentProps}
            showSquareAvatar={showSquareAvatar}
          />
        }
      >
        {children ? (
          children
        ) : (
          <Button
            variant={
              customButtonVariant ? customButtonVariant : "inline-progressive"
            }
            type={buttonType}
            shouldStopPropagation={true}
            className={classes.buttonContainer}
            testId={testId ? testId : undefined}
            style={customButtonStyle}
            dsVersion={dsVersion}
          >
            <div className={overrideClasses.buttonLabel}>
              {`${filteredDataCount} ${countLabel ? countLabel : ""}`}
            </div>
          </Button>
        )}
      </Dropdown>
    </div>
  );
});

ListPopup.displayName = "ListPopup";

export default I18nHOC({ resource: ["common"] })(ListPopup);
